import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getPinOptions() {
    return axios.get(ENV.appointmentApiBase + "/pins/list_options", this.requestConfig());
  }

  static getPinHistory(requestData) {
    return axios.post(ENV.appointmentApiBase + "/pins/view", requestData, this.requestConfig());
  }

  static updateRequest(requestData) {
    return axios.post(ENV.appointmentApiBase + "/manufacturers/requests/update", requestData, this.requestConfig());
  }
}

export default Service;
